import { Fragment } from "react/jsx-runtime";
import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { ActiveButtonsTitle, BoldBorderOutlineButtonsTitle, ButtonsTitle, DefaultButtonTitle, DefaultStyleTitle, DisabledButtonsTitle, FlatButtonTitle, GradienButtonsTitle, OutlineButtonsTitle, RaisedButtonTitle, SizingButtonsTitle } from "../../../Constants/Constants";
import { ActiveButtonsData, ActiveButtonSubTitle, BoldBorderOutlineButtonsData, BoldBorderOutlineButtonSubTitle, DefaultButtonsData, DefaultButtonText, DisableButtonsData, DisabledButtonSubTitle, FlatButtonSubTitle, GradienButtonsSubTitle, GradientButtonsData, OutlineButtonsData, OutlineButtonSubTitle, RaisedButtonSubTitle, SizingButtonsData, SizingButtonSubTitle } from "../../../Data/ButtonsData/DefaultStyleData";
import { CommonButtons } from "../Common/CommonButtons";
const DefaultStyleContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={DefaultStyleTitle} parent={ButtonsTitle} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <CommonButtons commonButtonsData={DefaultButtonsData} title={DefaultButtonTitle} subTitle={DefaultButtonText} />
            <CommonButtons className="btn-square" commonButtonsData={DefaultButtonsData} title={FlatButtonTitle} subTitle={FlatButtonSubTitle} />
            <CommonButtons raised className="btn-pill" commonButtonsData={DefaultButtonsData} title={RaisedButtonTitle} subTitle={RaisedButtonSubTitle} />
            <CommonButtons commonButtonsData={SizingButtonsData} title={SizingButtonsTitle} subTitle={SizingButtonSubTitle} />
            <CommonButtons commonButtonsData={ActiveButtonsData} title={ActiveButtonsTitle} subTitle={ActiveButtonSubTitle} />
            <CommonButtons commonButtonsData={DisableButtonsData} title={DisabledButtonsTitle} subTitle={DisabledButtonSubTitle} />
            <CommonButtons commonButtonsData={OutlineButtonsData} title={OutlineButtonsTitle} subTitle={OutlineButtonSubTitle} />
            <CommonButtons commonButtonsData={BoldBorderOutlineButtonsData} title={BoldBorderOutlineButtonsTitle} subTitle={BoldBorderOutlineButtonSubTitle} />
            <CommonButtons commonButtonsData={GradientButtonsData} title={GradienButtonsTitle} subTitle={GradienButtonsSubTitle} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default DefaultStyleContainer;
